<div class="p-1 pt-2 mt-0 flex justify-content-center">
  <span>
    <h5 class="mb-0">{{fileName}} {{formatFileSize(fileSize)}}</h5>
  </span>
  <span class="absolute right-0 pr-6" pTooltip="Close View"> <button pButton icon="pi pi-times" class="p-button-danger p-button-text p-button-sm" (click)="onClose()"></button></span>
</div>
<div class="p-1 pt-2 mt-0 flex justify-content-between">
    <span >
      <button *ngIf="base64File" pButton pRipple type="button" icon="fas fa-print" class="round-icon-button ml-2"
      pTooltip="Print" tooltipPosition="top" (click)="printPdf()"></button>
    </span>
    <span *ngIf="isPDF()" class="w-7">
      <input type="text" class="border-round-md w-full" pInputText placeholder="Search in Document"
             [(ngModel)]="searchTermInPdf" name="searchInput" (keyup)="searchPdf(pdfViewer)"
             (keyup.enter)="searchPdf(pdfViewer)">
    </span>
    <span *ngIf="isText()" class="w-8">
        <input type="text" class="border-round-md w-full" pInputText placeholder="Search in Document"
               [(ngModel)]="searchTermInPdf" name="searchInput" (keyup)="searchText(jsonViewElement)"
               (keyup.enter)="searchText(jsonViewElement)">
      </span>
    <span>
            <button *ngIf="base64File" pButton pRipple type="button" icon="fas fa-download"
              class="p-button-rounded round-icon-button mr-3" (click)="onClickDownloadDocument()"  
              pTooltip="Download" tooltipPosition="top"></button>
       <button *ngIf="base64File && (isSuperuser || buttonConfig?.showShareButton)" pButton pRipple type="button" icon="fad fa-share-alt"
              class="p-button-rounded p-button-outlined outlined-rounded-button mr-3" 
              pTooltip="Share" tooltipPosition="top" (click)="op.toggle($event)()"></button>       
    </span>
  </div>
  <p-overlayPanel #op>
    <div class="flex flex-column gap-3 w-25rem">
        <div>
            <span class="font-medium text-900 block mb-2">Share this document</span>
            <p-inputGroup>
                <input pInputText [value]="currentUrl" readonly class="w-25rem" />
                <p-inputGroupAddon (click)="onClickCopyUrl()" pTooltip="Copy">
                    <i class="pi pi-copy"></i>
                </p-inputGroupAddon>
                <button type="button"  (click)="onClickShareDocument()" pButton pTooltip="Email" class="fas fa-envelope"></button>
            </p-inputGroup>
        </div>
    </div>
</p-overlayPanel>
  <div *ngIf="isPDF()" class="p-1 py-0 flex mb-1 flex justify-content-between">
    <span class=" p-buttonset ml-2">
      <button pButton pRipple type="button" icon="far fa-search-minus" class="round-icon-button"
              pTooltip="Zoom Out" tooltipPosition="top" (click)="zoomOut()" [disabled]="0.7 > zoomValue"></button>
      <button [disabled]="zoomValue == 1.0" pButton pRipple type="button" icon="fas fa-vector-square"
              class="round-icon-button" pTooltip="Default Zoom" tooltipPosition="top"
              (click)="zoomValue = 1.0"></button>
      <button pButton pRipple type="button" icon="far fa-search-plus" class="round-icon-button"
              pTooltip="Zoom In" tooltipPosition="top" (click)="zoomIn()" [disabled]="zoomValue > 1.5"></button>
    </span>
    <span class="flex justify-content-between">
      <span class=" p-buttonset mr-3">
        <button pButton pRipple type="button" icon="fas fa-chevron-left" class="round-icon-button"
                pTooltip="Previous Page" tooltipPosition="top" (click)="prevPage()" [disabled]="page === 1">
        </button>
        <button pButton pRipple type="button" icon="fas fa-chevron-right" class="round-icon-button"
                pTooltip="Next Page" tooltipPosition="top" (click)="nextPage()" [disabled]="page === totalPages">
        </button>
        <p>Page : <b>{{page}}</b> / {{totalPages}}</p>
      </span>
      <span>
        <button pButton pRipple type="button" icon="far fa-redo-alt" class="round-icon-button"
                pTooltip="Rotate" tooltipPosition="top" (click)="rotatePdf()"></button>
      </span>
    </span>
  </div>
  
  <!-- PDF Viewer -->
  <pdf-viewer *ngIf="isPDF()" #pdfViewer [show-find]="true" [zoom]="zoomValue" [page]="page"
              [rotation]="rotationAngle" [src]="url" [render-text]="true" [original-size]="false"
              class="w-full h-full" [show-borders]="false" 
              (after-load-complete)="afterLoadComplete($event)" (pagechanging)="pagechanging($event)">
  </pdf-viewer>
  
<!-- Text Files -->
 <span *ngIf="isText()">
    <p *ngIf="fileType?.includes('edi')" #jsonViewElement class="jsonView" [appHighlight]="searchTermInPdf" [caseSensitive]="false" [value]="fileContent" [innerHTML]="fileContent"></p>
    <p class="jsonView" #jsonViewElement *ngIf="fileType?.includes('xml')" [innerHTML]="encodeXml(fileContent)|highlight:searchTermInPdf"></p>
    <!-- <p *ngIf="fileType?.includes('json') || fileType?.includes('txt')" #jsonViewElement class="jsonView" [appHighlight]="searchTermInPdf" [caseSensitive]="false" [value]="fileContent">{{ fileContent }}</p> -->
    <pre
  *ngIf="fileType?.includes('json') || fileType?.includes('txt')"
  #jsonViewElement
  class="jsonView"
  [appHighlight]="searchTermInPdf"
  [caseSensitive]="false"
  [value]="fileContent"
>
{{ fileContent }}
</pre>
 </span>

<!-- Image Files -->
 <div  *ngIf="isImage()" class="image-file-view">
<img *ngIf="isImage()" [src]="fileContent" class="w-full" alt="Image Preview">
</div>
  <!-- Office Document Viewer (Excel, PowerPoint) -->
  <iframe *ngIf="isPPTFile()" [src]="url | safeUrl:'resourceUrl'" class="iframe-view"  frameborder="0" allowfullscreen></iframe>
  
  <!-- Fallback iFrame for unsupported types -->
  <!-- <iframe *ngIf="!isPDF() && !isImage() && !isText() && !isDocxDocument() && !isExcelDocument() && !isPPTFile()" title="File Viewer"
          [src]="url | safeUrl:'resourceUrl'"  class="iframe-view" frameborder="0" allowfullscreen></iframe> -->
    <!-- Docx Files -->
<div *ngIf="isDocxDocument()" id="docx-preview-container"></div>

<div *ngIf="isExcelDocument()" id="excel-sheet" class="excel-view">

  <div *ngFor="let sheet of sheetsData" class="sheet-container">

    <h2 class="sheet-title">
      {{ sheet.name }}
      <small>({{ sheet.totalRows | number }} rows)</small>
    </h2>

    <ng-container *ngIf="sheet.rows?.length; else noData">

      <p-table
        [value]="sheet.rows"
        [scrollable]="true"
        scrollHeight="600px"
        [virtualScroll]="true"
        [virtualScrollItemSize]="40"
        styleClass="p-datatable-sm">

        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let header of sheet.headers" style="min-width: 120px !important;">
              {{ header }}
            </th>
          </tr>
        </ng-template>

        <ng-template
          pTemplate="body"
          let-rowData
          let-rowIndex="rowIndex">

          <tr>
            <td
              *ngFor="let cell of rowData; trackBy: trackByIndex" style="min-width:120px !important">
              {{ cell }}
            </td>
          </tr>

        </ng-template>

      </p-table>

    </ng-container>

    <ng-template #noData>
      <p>No data available for this sheet.</p>
    </ng-template>

  </div>

</div>

<p-dialog  header="Send Email" [(visible)]="shareEmail" styleClass="w-7" [modal]="true" [closable]="true" (onHide)="onHideModal()">
  <app-share-email (resetEmailData)="onClickReset()" (sendEmailData)="onClickShare($event)"></app-share-email>
</p-dialog>          
<style>
  
:host {
  #docx-preview-container{
width: 100%;
 max-height: calc(100vh - 320px);
 overflow-y: scroll !important;
 overflow-x:scroll !important ;
 .docx-preview-wrapper{
    height: inherit !important;
    padding: 0 !important;
    width: inherit !important;
    .docx-preview{
        height: inherit !important;
        padding: 20pt !important;
        width: 100% !important;
        margin-bottom: 10px !important;
    } 
}
}
}
</style>